import { render, staticRenderFns } from "./CardContainer.vue?vue&type=template&id=4bfb061a&scoped=true&"
import script from "./CardContainer.vue?vue&type=script&lang=js&"
export * from "./CardContainer.vue?vue&type=script&lang=js&"
import style0 from "./CardContainer.vue?vue&type=style&index=0&id=4bfb061a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bfb061a",
  null
  
)

export default component.exports